import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * @classdesc manage.gaiheki.support（private モード）でログインした場合のみ画面に到達できるようにするガード
 * クライアントポータル（public モード）からは、URLを直接叩いても到達できないようにする
 */
@Injectable({ providedIn: 'root' })
export class PrivateModeGuard implements CanLoad, CanActivate {
  constructor(private http: HttpClient, private router: Router) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    return this.checkIsPrivate();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.checkIsPrivate();
  }

  private checkIsPrivate(): Observable<boolean> {
    return this.http.get<{ data: { is_private: boolean } }>('/app_mode').pipe(
      map((res) => res.data.is_private ?? true),
      map((isPrivate) => (isPrivate ? true : this.activateError()))
    );
  }

  private activateError(): boolean {
    // クライアントポータルから到達した場合はTOPページに遷移する
    this.router.navigate([''], { replaceUrl: true });
    return false;
  }
}
